'use strict';

import FormController from 'app/controllers/form';

class AgencyController extends FormController {
  /* @ngInject */
  constructor(AgenciesService, $scope, $mdDialog, $mdToast, $state, $location) {
    let agency = $scope.$parent.$resolve.agency;
    super(agency, 'Agencia', AgenciesService, null, 'agencies');

    Object.assign(this, {
      AgenciesService,
      $mdDialog,
      $mdToast,
      $state,
      $location
    });
    this.btnEnabled = true;
  }
}

export default AgencyController;
